import _sfc_main from "./DayViewRange.vue2.js";
/* empty css                  */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const DayViewRange = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-eeee3079"]]);
export {
  DayViewRange as default
};
//# sourceMappingURL=DayViewRange.vue.js.map
